"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSkeleton = void 0;
var _react = _interopRequireDefault(require("react"));
var _Skeleton = _interopRequireDefault(require("./Skeleton"));
var _reactTableV = _interopRequireDefault(require("react-table-v6"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var TableSkeleton = function TableSkeleton(props) {
  var _props$skeletonColumn = props.skeletonColumnCount,
    skeletonColumnCount = _props$skeletonColumn === void 0 ? 5 : _props$skeletonColumn,
    _props$skeletonRowCou = props.skeletonRowCount,
    skeletonRowCount = _props$skeletonRowCou === void 0 ? 5 : _props$skeletonRowCou,
    _props$loading = props.loading,
    loading = _props$loading === void 0 ? false : _props$loading;
  var columns = [];
  var singleRow = {};
  for (var i = 0; i < skeletonColumnCount; i++) {
    var head = {
      Header: /*#__PURE__*/_react.default.createElement(_Skeleton.default, {
        height: '12px'
      }),
      accessor: 'data' + i,
      resizable: false,
      headerClassName: 'rt-th rt-resizable-header tl-table-sticky-header-cell table-align-center '
    };
    singleRow['data' + i] = /*#__PURE__*/_react.default.createElement(_Skeleton.default, null);
    columns.push(head);
  }
  var makeRows = function makeRows() {
    return new Array(skeletonRowCount).fill(singleRow);
  };
  var data = makeRows();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "tl-table-main-container"
  }, loading && /*#__PURE__*/_react.default.createElement(_reactTableV.default, {
    data: data,
    columns: columns,
    showPagination: false,
    defaultPageSize: skeletonRowCount,
    getTrGroupProps: function getTrGroupProps() {
      return {
        style: {
          background: 'none',
          cursor: 'default'
        }
      };
    }
  }));
};
exports.TableSkeleton = TableSkeleton;